module.exports = __webpack_public_path__ + "static/img/tc-screen.9a5e579.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/tc-screen.svg
// module id = 1z+v
// module chunks = 21